export function changeHeader() {
  const frontPage = document.querySelector('.home');
  const enPage = document.querySelector('.page-template-page-en');
  if (!(frontPage || enPage)) return;
  const target = document.getElementById('js-header');
  if (!target) return;
  const trigger = document.querySelector('.c-mainVisual');

  const removeBg = (nav) => {
    nav.classList.remove('_bgWhite');
  };
  const addBg = (nav) => {
    nav.classList.add('_bgWhite');
  };
  const observerFunction = (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        addBg(target);
      } else {
        removeBg(target);
      }
    });
  };

  const observerOption = new IntersectionObserver(observerFunction, {
    root: null,
    rootMargin: '-50% 0px -50% 0px',
    threshold: 0,
  });

  const executeObserver = (observer) => {
    observer.observe(trigger);
  };

  executeObserver(observerOption);
}
